import { Card, Skeleton } from '@parrot-software/design-system';

const DEFAULT_COUNT = 3;

interface SubscriptionBlockCardSkeletonProps {
  count?: number;
}

/**
 * SubscriptionBlockCardSkeleton - Loading placeholder for SubscriptionBlockCard.
 *
 * Mirrors the card anatomy (status band, identity header, price line, divider and the
 * two data columns) so the list keeps its height when the real data arrives.
 */
export const SubscriptionBlockCardSkeleton = ({ count = DEFAULT_COUNT }: SubscriptionBlockCardSkeletonProps) => {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <Card className="overflow-hidden rounded-2xl font-sans shadow-xs" key={`skeleton-${i}`}>
          <div className="flex">
            <div className="w-2 shrink-0 self-stretch bg-muted/50" />

            <div className="flex min-w-0 flex-1 flex-col gap-3.5 p-4">
              <div className="flex flex-col gap-3 md:flex-row md:items-center">
                <div className="flex min-w-0 flex-1 items-center gap-3">
                  <Skeleton className="h-10 w-10 shrink-0 rounded" />
                  <div className="flex min-w-0 flex-1 flex-col gap-1">
                    <Skeleton className="h-6 w-56 max-w-full" />
                    <Skeleton className="h-5 w-40 max-w-full" />
                  </div>
                </div>
                <Skeleton className="hidden h-9 w-24 rounded-md md:block" />
              </div>

              <div className="flex flex-col gap-1">
                <Skeleton className="h-9 w-40" />
                <Skeleton className="h-5 w-56 max-w-full" />
              </div>

              <div className="h-px w-full bg-border" />

              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div className="flex flex-col gap-1">
                  <Skeleton className="h-3 w-24" />
                  <Skeleton className="h-5 w-40 max-w-full" />
                  <Skeleton className="h-5 w-32 max-w-full" />
                </div>
                <div className="flex flex-col gap-1">
                  <Skeleton className="h-3 w-28" />
                  <Skeleton className="h-5 w-44 max-w-full" />
                  <Skeleton className="h-5 w-36 max-w-full" />
                </div>
              </div>

              <Skeleton className="h-9 w-full rounded-md md:hidden" />
            </div>
          </div>
        </Card>
      ))}
    </>
  );
};
